import React from "react";
import { Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import Select from "react-select";

const EmployeeReviewFilter = ({
    projectOptions,
    departmentOptions,
    subDeptOptions,
    employeeOptions,
    idcOptions,
    project,
    setProject,
    department,
    setDepartment,
    subDepartment,
    setSubDepartment,
    resource,
    setResource,
    idcMin,
    setIdcMin,
    idcMax,
    setIdcMax,
    qwdMin,
    setQwdMin,
    qwdMax,
    setQwdMax,
    reviewDate,
    setReviewDate,
    onSubmit,
    onClear,
    role
}) => {

    const selectStyle = {
        menuPortalTarget: document.body,
        styles: {
            menuPortal: (base) => ({ ...base, zIndex: 9999 })
        }
    };

    const isEmployee = ["teamlead", "manager"].includes(role?.toLowerCase());
    return (
        <Row className="mb-3 p-3 rounded bg-light">

            {/* ================= EMPLOYEE VIEW ================= */}
            {isEmployee ? (
                <>
                    <Col md={3}>
                        <Form.Label>Project</Form.Label>
                        <Select
                            options={projectOptions}
                            value={project}
                            onChange={setProject}
                            {...selectStyle}
                        />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Employee</Form.Label>
                        <Select
                            options={employeeOptions}
                            value={resource}
                            onChange={setResource}
                            {...selectStyle}
                        />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Review Date</Form.Label>
                        <Form.Control
                            type="date"
                            value={reviewDate}
                            onChange={(e) => setReviewDate(e.target.value)}
                        />
                    </Col>


                    {/* Buttons same row */}
                    <Col md={3} className="d-flex align-items-end gap-2">
                        <Button className="primaryBtn w-50" onClick={onSubmit}>
                            Submit
                        </Button>
                        <Button className="clearBtn w-50" onClick={onClear}>
                            Clear
                        </Button>
                    </Col>
                </>
            ) : (
                <>
                    {/* ================= ADMIN VIEW ================= */}

                    <Col md={3}>
                        <Form.Label>Project</Form.Label>
                        <Select options={projectOptions} value={project} onChange={setProject} {...selectStyle} />
                    </Col>
                    <Col md={3}>
                        <Form.Label>Employee</Form.Label>
                        <Select
                            options={employeeOptions}
                            value={resource}
                            onChange={setResource}
                            {...selectStyle}
                        />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Department</Form.Label>
                        <Select options={departmentOptions} value={department} onChange={setDepartment} {...selectStyle} />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Sub Department</Form.Label>
                        <Select
                            options={subDeptOptions}
                            value={subDepartment}
                            onChange={setSubDepartment}
                            isDisabled={!department}
                            {...selectStyle}
                        />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Review Date</Form.Label>
                        <Form.Control
                            type="date"
                            value={reviewDate}
                            onChange={(e) => setReviewDate(e.target.value)}
                        />
                    </Col>

                    {/* Buttons */}
                    <Col md={3} className="d-flex align-items-end gap-2 mt-2">
                        <Button className="primaryBtn w-50" onClick={onSubmit}>Submit</Button>
                        <Button className="clearBtn w-50" onClick={onClear}>Clear</Button>
                    </Col>
                </>
            )}

        </Row>
    );
};

export default EmployeeReviewFilter;